<mat-drawer-container class="example-container relative full-height" [hasBackdrop]="false">
  <mat-drawer #drawer mode="over" style="min-width: 600px; width: 60%" position="end" [autoFocus]="false" [opened]="drawer.opened && !(dataSourcesCustomLoading$ | async)">
    <div *ngIf="drawerDataSource" class="display-flex flex-column full-height">
      <div class="container">
        <div class="drawer-header">
          <h2>
            <app-source [item]="drawerDataSource.payload.relationships.data_source?.data"
                        [enableName]="false">
              {{ drawerDataSource.payload.relationships.data_source?.data.attributes.name }} - {{ 'data_sources.custom_sources.imports.list' | translate }}
            </app-source>
          </h2>
          <div>
            <button mat-icon-button
                    color="secondary"
                    [disabled]="appS.isNotDatasetAdmin || ['email', 'sftp', 'ftp'].includes(drawerDataSource.payload.relationships.data_set_usage_custom_configuration.data.attributes.import_method) && ['ok', 'paused'].includes(drawerDataSource.payload.attributes.status)"
                    (click)="openIframe.openDialog({inputData: { link: drawerDataSource.payload.relationships.data_set.data.id+'/data-sources/'+drawerDataSource.payload.relationships.data_source?.data.id+'/'+drawerDataSource.payload.id+'/custom-imports/start' }})"
                    [matTooltip]="'data_sources.custom_sources.imports.add_data' | translate">
              <mat-icon>upload</mat-icon>
            </button>
            <button mat-icon-button (click)="drawer.close()" [matTooltip]="'button.close' | translate">
              <mat-icon class="color-red-hover">close</mat-icon>
            </button>
          </div>
        </div>
        <div class="drawer-info">
          <ng-container [ngSwitch]="drawerDataSource.payload.relationships.data_set_usage_custom_configuration.data.attributes.import_method">
            <ng-container *ngSwitchCase="'email'">
              <div class="badges-container">
                <app-custom-sources-badge-mail [datasource]="drawerDataSource"></app-custom-sources-badge-mail>
                <app-custom-sources-badge-dimensions [datasource]="drawerDataSource"></app-custom-sources-badge-dimensions>
                <app-custom-sources-badge-metrics [datasource]="drawerDataSource"></app-custom-sources-badge-metrics>
                <app-custom-sources-badge-currency [datasource]="drawerDataSource"></app-custom-sources-badge-currency>
                <app-custom-sources-badge-aggregation-type [datasource]="drawerDataSource"></app-custom-sources-badge-aggregation-type>
              </div>
              <app-custom-sources-warning-file-info [datasource]="drawerDataSource">
                {{ 'data_sources.custom_imports.email_info' | translate: { email: 'imports+' + drawerDataSource.payload.relationships.data_set_usage_custom_configuration.data.attributes.parameters['mail_hash'] + '@adloop.co'  } }}
              </app-custom-sources-warning-file-info>
            </ng-container>
            <ng-container *ngSwitchCase="'ftp'">
              <div class="badges-container">
                <app-custom-sources-badge-ftp [datasource]="drawerDataSource"></app-custom-sources-badge-ftp>
                <app-custom-sources-badge-dimensions [datasource]="drawerDataSource"></app-custom-sources-badge-dimensions>
                <app-custom-sources-badge-metrics [datasource]="drawerDataSource"></app-custom-sources-badge-metrics>
                <app-custom-sources-badge-currency [datasource]="drawerDataSource"></app-custom-sources-badge-currency>
                <app-custom-sources-badge-aggregation-type [datasource]="drawerDataSource"></app-custom-sources-badge-aggregation-type>
              </div>
              <app-custom-sources-warning-file-info [datasource]="drawerDataSource">
                {{ 'data_sources.custom_imports.ftp_info' | translate: { folder: drawerDataSource.payload.relationships.data_set_usage_custom_configuration.data.attributes.parameters['ftp_configuration']['folder'] } }}
              </app-custom-sources-warning-file-info>
            </ng-container>
            <ng-container *ngSwitchCase="'sftp'">
              <div class="badges-container">
                <app-custom-sources-badge-ftp [datasource]="drawerDataSource"></app-custom-sources-badge-ftp>
                <app-custom-sources-badge-dimensions [datasource]="drawerDataSource"></app-custom-sources-badge-dimensions>
                <app-custom-sources-badge-metrics [datasource]="drawerDataSource"></app-custom-sources-badge-metrics>
                <app-custom-sources-badge-currency [datasource]="drawerDataSource"></app-custom-sources-badge-currency>
                <app-custom-sources-badge-aggregation-type [datasource]="drawerDataSource"></app-custom-sources-badge-aggregation-type>
              </div>
              <app-custom-sources-warning-file-info [datasource]="drawerDataSource">
                {{ 'data_sources.custom_imports.sftp_info' | translate: { folder: drawerDataSource.payload.relationships.data_set_usage_custom_configuration.data.attributes.parameters['ftp_configuration']['folder'] } }}
              </app-custom-sources-warning-file-info>
            </ng-container>
            <ng-container *ngSwitchDefault>
              <div class="badges-container">
                <app-custom-sources-badge-one-shot [datasource]="drawerDataSource"></app-custom-sources-badge-one-shot>
                <app-custom-sources-badge-dimensions [datasource]="drawerDataSource"></app-custom-sources-badge-dimensions>
                <app-custom-sources-badge-metrics [datasource]="drawerDataSource"></app-custom-sources-badge-metrics>
                <app-custom-sources-badge-currency [datasource]="drawerDataSource"></app-custom-sources-badge-currency>
                <app-custom-sources-badge-aggregation-type [datasource]="drawerDataSource"></app-custom-sources-badge-aggregation-type>
              </div>
              <app-custom-sources-warning-file-info [datasource]="drawerDataSource">
                {{ 'data_sources.custom_imports.one_shot_info' | translate }}
              </app-custom-sources-warning-file-info>
            </ng-container>
          </ng-container>
        </div>
      </div>
      <mat-accordion class="import-listing-expansion-panel flex-grow">
        <app-ag-grid [gridOptions]="{
                        suppressDragLeaveHidesColumns: true,
                        groupHeaderHeight: 40,
                        headerHeight: 40,
                        rowHeight: 40,
                        colResizeDefault: 'shift'
                     }"
                     [paginationPageSize]="25"
                     noRowsOverlayComponent="customOverlayNoRows"
                     [noRowsOverlayComponentParams]="{ noRowsMessage: 'data_sources.noRowsSentence' }"
                     [suppressContextMenu]="true"
                     [defaultColDef]="defaultColDef"
                     [columnDefs]="drawerColumnDefs"
                     [rowData]="drawerDataSource.datasetUsageCustomImports$ | async"
                     class="cell-no-border">
        </app-ag-grid>
      </mat-accordion>
    </div>
  </mat-drawer>
  <mat-drawer-content class="relative full-height">
    <div class="display-flex flex-column full-height">
      <app-jumbotron class="mb-10">
        <div class="container display-flex flex-align-center page-help">
          <div class="flex-grow mr-10">
          </div>
          <div *ngIf="(space$ | async).attributes.plan_error else elseButton;"
               class="display-flex flex-align-center gap-1-rem">
            <app-help-button template="custom-sources"></app-help-button>
            <app-button
              [matTooltip]="'data_sources.plan_paused' | translate"
              [matTooltipPosition]="'left'"
              icon="lock"
              *ngIf="isSuperAdmin$ | async"
              buttonType="mat-flat-button">{{ 'button.add' | translate }}
            </app-button>
          </div>
          <ng-template #elseButton>
            <div class="display-flex flex-align-center gap-1-rem">
              <app-help-button template="custom-sources"></app-help-button>
              <app-button icon="add"
                          [disabled]="appS.isNotDatasetAdmin"
                          *ngIf="isSuperAdmin$ | async"
                          buttonType="mat-flat-button"
                          (onClick)="openIframe.openDialog({ inputData: { link: this.dataSourcesS.getSetupLink(dataSourceCustom) } });"
                          id="tour-add-data-source">{{ 'button.add' | translate }}</app-button>
            </div>
          </ng-template>
        </div>
      </app-jumbotron>
      <app-jumbotron id="table-container"
                     class="full-height flex-grow">
        <app-ag-grid [gridOptions]="{
                        suppressDragLeaveHidesColumns: true,
                        groupHeaderHeight: 64,
                        headerHeight: 64,
                        rowHeight: 82,
                        colResizeDefault: 'shift'
                     }"
                     [loader]="dataSourcesCustomLoading$ | async"
                     [paginationPageSize]="25"
                     noRowsOverlayComponent="customOverlayNoRows"
                     [noRowsOverlayComponentParams]="{ noRowsMessage: 'data_sources.noRowsSentence' }"
                     [suppressContextMenu]="true"
                     [defaultColDef]="defaultColDef"
                     [columnDefs]="columnDefs"
                     [rowData]="dataSourcesCustom$ | async"
                     class="cell-no-border">
        </app-ag-grid>
      </app-jumbotron>
    </div>
  </mat-drawer-content>
</mat-drawer-container>

<app-dialog #openIframe [config]="dialogOpenIframeConfig" (onClose)="drawer.close();"></app-dialog>

<ng-template #logo let-row let-params="params">
  <div class="full-height display-flex flex-align-center fw-500 fz-1-1rem">
    <app-source [item]="row.payload.relationships.data_source?.data"
                [enableName]="false">
      <span>{{ row.payload.relationships.data_source?.data.attributes.name }}</span>
      <span *ngIf="row.payload.attributes.parameters?.using_adloop" style="color: #888; font-size: 0.7em;">
        <br/>With Adloop Attribution & Recommendations
      </span>
    </app-source>
  </div>
</ng-template>
<ng-template #imported let-row let-params="params">
  <div class="full-height line-height-1-5-rem pt-5 pb-5" [innerHtml]="row.payload.attributes.imported || '-' | safeHtml"></div>
</ng-template>
<ng-template #enabled let-row let-params="params">
  <div class="full-height display-flex flex-align-center line-height-1-5-rem pt-5 pb-5">
    <div *ngIf="row.payload.attributes.plan_paused else elseEnabled;">
      <mat-slide-toggle [checked]="false"
                        [disabled]="true"
                        color="primary"></mat-slide-toggle>
    </div>
    <ng-template #elseEnabled>
      <mat-slide-toggle [checked]="row.payload.attributes.enabled"
                        [disabled]="appS.isNotDatasetAdmin || row.payload.relationships.data_source.data.attributes.classname == 'CustomOfflineDataSource'"
                        color="primary"
                        (change)="enabledToggled($event, row)"></mat-slide-toggle>
    </ng-template>
  </div>
</ng-template>
<ng-template #desc let-row>
  <div class="display-flex flex-align-center full-height">
    <ng-container *ngIf="row.payload.relationships.data_source.data.attributes.classname != 'CustomOfflineDataSource'">
      <app-button icon="visibility"
                  (click)="onCustomImportFilter(row)"
                  *ngIf="(row.datasetUsageCustomImports$ | async).length; else elseBlockNewUploadButton"
                  [matTooltip]="'tooltip.show_custom_imports' | translate">
        {{ (row.datasetUsageCustomImports$ | async).length }}
        <ng-container *ngIf="(row.datasetUsageCustomImports$ | async).length === 1 && row.payload.attributes.status == 'not-configured'; else manyImports">
          {{ 'data_sources.custom_sources.imports.imported_files_duplicated' | translate }}
        </ng-container>

        <ng-template #manyImports>
          <ng-container *ngIf="(row.datasetUsageCustomImports$ | async).length > 1; else oneImport">
            {{ 'data_sources.custom_sources.imports.imported_files_many' | translate }}
          </ng-container>
        </ng-template>

        <ng-template #oneImport>
          {{ 'data_sources.custom_sources.imports.imported_files_one' | translate }}
        </ng-template>
      </app-button>
    </ng-container>
  </div>
  <ng-template #elseBlockNewUploadButton>
    <app-button icon="settings"
                buttonType="mat-stroked-button"
                (onClick)="openIframe.openDialog({inputData: { link: row.payload.relationships.data_set.data.id+'/data-sources/'+row.payload.relationships.data_source?.data.id+'/'+row.payload.id+'/custom-imports/start' }})">
      {{ 'data_sources.custom_sources.imports.configure' | translate }}
    </app-button>
  </ng-template>
</ng-template>
<ng-template #status let-row>
  <div class="full-height display-flex flex-align-center">
    <div *ngIf="row.payload.attributes.plan_paused else elseStatus;">
      <app-data-source-status [status]="'paused'"
                              [tooltipActivated]="true"
                              [tooltipMessage]="'data_sources.plan_paused' | translate"></app-data-source-status>
    </div>
    <ng-template #elseStatus>
      <app-data-source-status [status]="row.payload.attributes.status"
                              [tooltipActivated]="(row.payload.attributes.status == 'error' ? true : false)"
                              [tooltipMessage]="(row.payload.attributes.status == 'error' ? 'data_sources.custom_sources.imports.file_error' : null) | translate"></app-data-source-status>
    </ng-template>
  </div>
</ng-template>
<ng-template #actions let-row>
  <div class="actions full-height display-flex flex-align-center justify-content-end">
    <ng-container *ngIf="row.payload.relationships.data_source.data.attributes.classname != 'CustomOfflineDataSource'">
      <app-icon icon="format_list_bulleted"
                [style]="'material-icons-outlined cursor color-grey-light color-yellow-hover'"
                *ngIf="row.payload.relationships.data_set_usage_custom_configuration.data && row.payload.relationships.data_source?.data.attributes.data_source_group.slug === 'custom' &&
                                !['unknown', 'not-configured'].includes(row.payload.attributes.status)"
                class="display-inline-flex"
                [disabled]="appS.isNotDatasetAdmin"
                [matTooltip]="'tooltip.show_custom_imports' | translate"
                (onClick)="onCustomImportFilter(row)"></app-icon>
      <app-icon
        [icon]="row.payload.relationships.data_source?.data.attributes.data_source_group.slug === 'custom' && 'upload' || 'settings'"
        [style]="'material-icons-outlined cursor color-grey-light color-blue-hover'"
        [disabled]="appS.isNotDatasetAdmin || row.payload.relationships.data_set_usage_custom_configuration.data && ['email', 'sftp', 'ftp'].includes(row.payload.relationships.data_set_usage_custom_configuration.data.attributes.import_method) && ['ok', 'paused'].includes(row.payload.attributes.status)"
        class="display-inline-flex"
        [matTooltip]="'data_sources.custom_sources.imports.add_data' | translate"
        (onClick)="openIframe.openDialog({inputData: { link: row.payload.relationships.data_set.data.id+'/data-sources/'+row.payload.relationships.data_source?.data.id+'/'+row.payload.id+'/custom-imports/start' }})">
      </app-icon>
    </ng-container>
    <app-icon
      icon="delete"
      [style]="'material-icons-outlined cursor color-grey-light color-red-hover'"
      [disabled]="appS.isNotDatasetAdmin"
      class="display-inline-flex"
      [matTooltip]="'tooltip.delete' | translate"
      (onClick)="openIframe.openDialog({ inputData: { link: row.payload.relationships.data_set.data.id+'/data-sources/'+row.payload.relationships.data_source?.data.id+'/'+row.payload.id+'/delete' } })">
    </app-icon>
  </div>
</ng-template>
<ng-template #drawerImportDates let-row>
  <div class="full-height display-flex flex-align-center">
    <span *ngIf="row.payload.attributes.imported_period.start_date; else elseBlockImportDatesNone">
    {{ row.payload.attributes.imported_period.start_date }} -> {{ row.payload.attributes.imported_period.end_date }}
    </span>
  </div>
  <ng-template #elseBlockImportDatesNone>
    -
  </ng-template>
</ng-template>
<ng-template #drawerActions let-row>
  <div class="full-height display-flex flex-align-center justify-content-end gap-1-rem">
    <app-icon [style]="'material-icons-outlined cursor color-grey-light color-black-hover'"
              icon="info"
              class="display-inline-flex"
              customToolTip
              [contentTemplate]="customImportTooltip"></app-icon>
    <ng-template #customImportTooltip>
      <app-custom-sources-tooltip-file-info [customImport]="row"></app-custom-sources-tooltip-file-info>
    </ng-template>
    <app-download-custom-data-source class="display-inline-flex"
                                     [row]="row.payload"></app-download-custom-data-source>
    <app-icon icon="delete"
              [style]="'material-icons-outlined cursor color-grey-light color-red-hover'"
              [disabled]="appS.isNotDatasetAdmin"
              class="display-inline-flex"
              [matTooltip]="'tooltip.delete' | translate"
              (onClick)="onDelete(row.payload)"></app-icon>
  </div>
</ng-template>
